function quickAddMakeTemplate(element) {
  const productContainer = element.querySelector('.product');
  if (!productContainer) return element;

  const productMedia = productContainer.querySelector('.product__media-wrapper');
  const productTitle = productContainer.querySelector('.product__title');
  const productPrice = productContainer.querySelector('[id^="price-template--"]');
  const productVariants = productContainer.querySelector('variant-radios') || productContainer.querySelector('variant-selects');
  const productQuantity = productContainer.querySelector('.product-form__quantity');
  const productForm = productContainer.querySelector('product-form');

  const titleH1 = productTitle ? productTitle.querySelector('h1') : null;
  const titleSub = productTitle ? productTitle.querySelector('.product__subtitle') : null;

  let html = `
  <div class="quick-add-drawer">
      <div class="product__title">
          ${titleH1 ? `<p class="quick-add__title">${titleH1.textContent.trim()}</p>` : ''}
          ${titleSub ? `<p class="quick-add__subtitle">${titleSub.textContent.trim()}</p>` : ''}
      </div>
      ${productMedia ? `<div class="product__media">${productMedia.outerHTML}</div>` : ''}
      ${productPrice ? `<div class="product__price">${productPrice.outerHTML}</div>` : ''}
      ${productVariants ? `<div class="product__selector">${productVariants.outerHTML}</div>` : ''}
      <div class="product__qty-form-wrap">
          ${productQuantity ? `<div class="product__quantity">${productQuantity.outerHTML}</div>` : ''}
          ${productForm ? `<div class="product__form">${productForm.outerHTML}</div>` : ''}
      </div>
  </div>`;

  productContainer.innerHTML = html;
  return element;
}

if (!customElements.get('quick-add-modal')) {
    customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            const template = quickAddMakeTemplate(this.productElement);
            this.setInnerHTML(this.modalContent, template.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach(oldScriptTag => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach(attribute => {
            newScriptTag.setAttribute(attribute.name, attribute.value)
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantSelector = this.modalContent.querySelector('variant-radios,variant-selects');
        if (variantSelector) variantSelector.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
        this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
          variantSelect.dataset.originalSection = sectionId;
        });
      }
    });
  }


  if (!customElements.get('quick-add-drawer')) {
      customElements.define('quick-add-drawer', class QuickAddDrawer extends HTMLElement {
        constructor() {
          super();
          this.drawerContent = this.querySelector('#QuickAddDrawerContent');
        }

        hide(preventFocus = false) {
          const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cartNotification) cartNotification.setActiveElement(this.openedBy);
          this.drawerContent.innerHTML = '';

          if (preventFocus) this.openedBy = null;
          super.hide();
        }

        open(triggeredBy) {
          if (triggeredBy) this.setActiveElement(triggeredBy);
          const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
          // here the animation doesn't seem to always get triggered. A timeout seem to help
          setTimeout(() => {this.classList.add('animate', 'active')});

          this.addEventListener('transitionend', () => {
            const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            trapFocus(containerToTrapFocusOn, focusElement);
          }, { once: true });

          document.body.classList.add('overflow-hidden');
        }

        close() {
          this.classList.remove('active');
          removeTrapFocus(this.activeElement);
          document.body.classList.remove('overflow-hidden');
        }

        show(opener) {
          opener.setAttribute('aria-disabled', true);
          opener.classList.add('loading');
          opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

          fetch(opener.getAttribute('data-product-url'))
            .then((response) => response.text())
            .then((responseText) => {
              const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
              this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

              const html = quickAddMakeTemplate(this.productElement);

              this.preventDuplicatedIDs();
              this.removeDOMElements();
              this.setInnerHTML(this.drawerContent, html.innerHTML);

              if (window.Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }

              if (window.ProductModel) window.ProductModel.loadShopifyXR();

              this.removeGalleryListSemantic();
              this.preventVariantURLSwitching();
              this.open(opener);
            })
            .finally(() => {
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
              opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        }

        setInnerHTML(element, html) {
          element.innerHTML = html;

          // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
          element.querySelectorAll('script').forEach(oldScriptTag => {
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach(attribute => {
              newScriptTag.setAttribute(attribute.name, attribute.value)
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
          });
        }

        setActiveElement(element) {
          this.activeElement = element;
        }

        preventVariantURLSwitching() {
          const variantSelector = this.drawerContent.querySelector('variant-radios,variant-selects');
          if (variantSelector) variantSelector.setAttribute('data-update-url', 'false');
        }

        removeDOMElements() {
          const pickupAvailability = this.productElement.querySelector('pickup-availability');
          if (pickupAvailability) pickupAvailability.remove();

          const productModal = this.productElement.querySelector('product-modal');
          if (productModal) productModal.remove();
        }

        preventDuplicatedIDs() {
          const sectionId = this.productElement.dataset.section;
          this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
          this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
            variantSelect.dataset.originalSection = sectionId;
          });
        }

        removeGalleryListSemantic() {
          const galleryList = this.drawerContent.querySelector('[id^="Slider-Gallery"]');
          if (!galleryList) return;

          galleryList.setAttribute('role', 'presentation');
          galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
        }
      });
    }
